import type {NavigateFunction} from 'react-router-dom';

let navigateFn: NavigateFunction | null = null;
let currentDepth = 0;

export const setNavigate = (fn: NavigateFunction) => {
    navigateFn = fn;
};

/** Kept in sync by useModalRoute on every navigation, including native back/forward. */
export const setDepth = (depth: number) => {
    currentDepth = depth;
};

const getSearch = () => window.location.search;

const push = (search: string) => {
    if (new URLSearchParams(getSearch()).toString() === search) return;
    navigateFn?.(`${window.location.pathname}${search ? `?${search}` : ''}`);
};

const pop = (count: number) => {
    if (count > 0) navigateFn?.(-count);
};

const getDepth = () => currentDepth;

const replace = (search: string) => {
    navigateFn?.(`${window.location.pathname}${search ? `?${search}` : ''}`, {replace: true});
};

export default {setNavigate, setDepth, getDepth, getSearch, push, pop, replace};
